export const PAYMENT_SELECTION_STATES = {
  IDLE: 'idle',
  EXISTING_SELECTED: 'existingSelected',
  NEW_CARD_SELECTED: 'newCardSelected',
  PAYPAL_SELECTED: 'paypalSelected',
  APPLE_PAY_SELECTED: 'applePaySelected',
} as const;

export type PaymentSelectionState =
  (typeof PAYMENT_SELECTION_STATES)[keyof typeof PAYMENT_SELECTION_STATES];
